export default {
  xs: {
    max: 349
  },
  sm: {
    min: 350,
    max: 699
  },
  md: {
    min: 700,
    max: 849
  },
  lg: {
    min: 850,
    max: 1023
  },
  xl: {
    min: 1024,
    max: 1327
  },
  xxl: {
    min: 1328
  }
};
